import { Link } from "react-router-dom";
import type { Series } from "@/mocks/series";

interface SeriesCardProps {
  series: Series;
  showFavorite?: boolean;
  isFavorite?: boolean;
  onToggleFavorite?: (id: string) => void;
}

export default function SeriesCard({
  series,
  showFavorite = false,
  isFavorite = false,
  onToggleFavorite,
}: SeriesCardProps) {
  return (
    <article className="group relative overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300">
      <Link to={`/detail/${series.id}`} className="block">
        <div className="relative aspect-[3/4] w-full overflow-hidden bg-background-200">
          <img
            src={series.poster}
            alt={`${series.title} 剧集海报`}
            title={`${series.title} 仙侠剧集封面`}
            className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-primary-950/70 via-transparent to-transparent"></div>
          <span className="absolute left-3 top-3 flex items-center gap-1 rounded-md bg-accent-500 px-2 py-1 text-xs font-semibold text-primary-950">
            <i className="ri-star-fill"></i>
            {series.rating.toFixed(1)}
          </span>
          <span className="absolute bottom-3 left-3 rounded-md bg-background-50/90 px-2 py-1 text-xs font-medium text-primary-700">
            {series.year} · {series.category}
          </span>
        </div>
      </Link>

      {showFavorite && (
        <button
          type="button"
          aria-label={isFavorite ? "取消收藏" : "收藏剧集"}
          onClick={() => onToggleFavorite?.(series.id)}
          className={`absolute right-3 top-3 flex h-8 w-8 cursor-pointer items-center justify-center rounded-full backdrop-blur transition-colors ${
            isFavorite
              ? "bg-accent-500 text-primary-950"
              : "bg-background-50/80 text-foreground-600 hover:text-primary-600"
          }`}
        >
          <i className={isFavorite ? "ri-bookmark-fill" : "ri-bookmark-line"}></i>
        </button>
      )}

      <div className="p-3 md:p-4">
        <h3 className="truncate font-heading text-base font-semibold text-foreground-900">
          <Link to={`/detail/${series.id}`} className="hover:text-primary-700">
            {series.title}
          </Link>
        </h3>
        <p className="mt-1.5 line-clamp-2 text-xs leading-relaxed text-foreground-600 md:text-sm">
          {series.summary[0]}
        </p>
        <div className="mt-3 flex flex-wrap gap-1.5">
          {series.tags.slice(0, 3).map((tag) => (
            <span
              key={tag}
              className="rounded-full bg-secondary-100 px-2 py-0.5 text-[11px] text-secondary-800"
            >
              {tag}
            </span>
          ))}
        </div>
      </div>
    </article>
  );
}